import { createRouter, createWebHistory } from 'vue-router'
import { checkAuth, consumeAccessTokenFromUrl } from '@/composables/useAuth'
const routes = [
    {
        path: '/',
        component: () => import('@/layouts/marketing/MarketingLayout.vue'),
        children: [
            {
                path: '',
                name: 'Home',
                component: () => import('@/views/HomePage.vue'),
            },
            {
                path: 'learn/terrain',
                name: 'TerrainGuide',
                component: () => import('@/views/TerrainGuide.vue'),
            }
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/LoginPage.vue'),
    },
    {
        path: '/link-callback',
        name: 'LinkCallback',
        component: () => import('@/views/LinkCallback.vue'),
    },
    {
        path: '/oauth-callback/:provider',
        name: 'OAuthCallback',
        component: () => import('@/views/OAuthCallback.vue'),
    },
    {
        path: '/Map',
        component: () => import('@/layouts/default/DefaultLayout.vue'),
        children: [
            { 
                path: '',
      name: 'MapApp',
                component: () => import('@/components/MapApp.vue') }
        ]
    },
    {
        path: '/Profile',
        component: () => import('@/layouts/default/DefaultLayout.vue'),
        children: [
            {
                path: '',
                name: 'Profile',
                component: () => import('@/views/Profile.vue'),
            }
        ]
    },
    {
        path: '/layer-status',
        component: () => import('@/layouts/default/DefaultLayout.vue'),
        children: [
            {
                path: '',
                name: 'LayerStatus',
                component: () => import('@/views/LayerStatus.vue'),
            }
        ]
    },
    {
        path: '/ballistics',
        component: () => import('@/layouts/default/DefaultLayout.vue'),
        children: [
            {
                path: '',
                name: 'BallisticsManager',
                component: () => import('@/views/BallisticsManager.vue'),
            },
            {
                path: 'rifle/:id?',
                name: 'AddEditRifle',
                component: () => import('@/views/AddEditRifle.vue'),
            },
            {
                path: 'rifle/:rifleId/ammo',
                name: 'AmmoManager',
                component: () => import('@/views/AmmoManager.vue'),
            },
            {
                path: 'shoot/:rifleId',
                name: 'ShootCalculator',
                component: () => import('@/views/ShootCalculator.vue'),
            },
            {
                path: 'drop-chart/:rifleId',
                name: 'DropChart',
                component: () => import('@/views/DropChart.vue'),
            },
            {
                path: 'settings',
                name: 'BallisticsSettings',
                component: () => import('@/views/BallisticsSettings.vue'),
            }
        ]
    },
    {
        path: '/share',
        component: () => import('@/layouts/default/DefaultLayout.vue'),
        children: [
            {
                path: ':token',
                name: 'ClaimBallisticShare',
                component: () => import('@/views/ClaimBallisticShare.vue'),
            }
        ]
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

// Navigation guard to protect authenticated routes
router.beforeEach(async (to, from, next) => {
    // Capture an accessToken handed back by the OAuth callback (e.g. /Map?accessToken=...).
    consumeAccessTokenFromUrl()

    // Routes that require authentication
    const protectedRoutes = ['/Map', '/ballistics', '/Profile', '/layer-status', '/share']
    const requiresAuth = protectedRoutes.some(route => to.path.startsWith(route))

    if (requiresAuth) {
        // sessionStorage dies with the tab. checkAuth restores a 30-day refresh cookie first.
        const ok = await checkAuth()
        if (!ok) {
            next({ path: '/login', query: { redirect: to.fullPath } })
            return
        }
    }

    next()
})

export default router